import { TipoVoucherAutomatico, TipoValor } from './enum';

export class VoucherAutomatico {
  id: number;
  tipo: TipoVoucherAutomatico;
  tipoDescricao: string;
  aCadaValor?: number;
  idClassificacao?: number;
  idModeloEmail?: number;
  valorMinimoPedido: number;
  prazoValidade: number;
  tipoValor: TipoValor;
  tipoValorDescricao: string;
  valor: number;
  codigo: string;
  beneficios: string;
  condicoes: string;
  descricao: string;
}
